import React, { useContext, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import { nightWorkingForm, nightWorkingSchema } from '../../data/formData';
import { yupResolver } from '@hookform/resolvers/yup';
import { DateUtils } from '../../utils/dateUtils';
import { MyContext } from '../../context';
import { makePostCall } from '../../effects/requests';
import { endPoints } from '../../utils/endpoints';
import { ApiResponseType } from '../../types';
import { emptyFunction, getCompanyName, showToast } from '../../utils';
import CustomTimePicker from '../../global/ui/CustomTimePicker';
import { apiConstants } from '../../utils/apiConstants';
import moment from 'moment';

interface IAllocateTimeModal {
    isShow: boolean;
    onClose: () => void;
    onDone: () => void;
    allocateData: any
}

const AllocateTimeModal: React.FC<IAllocateTimeModal> = (props) => {

    const { userData } = useContext(MyContext)


    const [isNightWorking, setIsNightWorking] = useState(false);

    const { ...methods } = useForm({
        mode: "all",
        defaultValues: { ...nightWorkingForm() },
        reValidateMode: "onBlur",
        resolver: yupResolver(nightWorkingSchema()),
    });


    const onSubmit = (values: any) => {
        if (moment(values?.end_time).isSame(moment(values?.start_time))) {
            showToast('Form time and to time can not be same', 'error', 'same_time');
            return
        }
        if (moment(values?.start_time).isAfter(moment(values?.end_time))) {
            showToast('To time can not be lesser than from time', 'error', 'lesser_time')
            return
        }
        const fd = new FormData();
        fd.append('user_id', props.allocateData?.data?.id || '');
        fd.append('date', `${DateUtils.formatDateTime(props.allocateData?.date, 'YYYY-MM-DD')}`);
        fd.append('production_company_name', getCompanyName(userData));
        fd.append('night_working', isNightWorking ? 'True' : 'False');
        fd.append('start_time', `${DateUtils.formatDateTime(values?.start_time, 'HH:mm')}`);
        fd.append('end_time', `${DateUtils.formatDateTime(values?.end_time, 'HH:mm')}`);
        makePostCall(endPoints.FLAT_DAY, fd).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                props.onDone();
            }
        }).catch(emptyFunction)
    }

    const { formState } = methods;

    const startTime = methods.getValues(apiConstants.start_time);
    const endTime = methods.getValues(apiConstants.end_time);

    return (
        <Modal
            centered
            scrollable
            show={props.isShow}
        >
            <div className='d-flex justify-content-between align-items-center'>
                <div className='d-flex justify-content-center align-items-center'>
                    <div onClick={props.onClose} className='noti-back-btn'>
                        <img src={"/assets/images/black-arrow-left-side.svg"} alt="" />
                    </div>
                    <span style={{ fontWeight: '700', color: '#000', fontSize: '14px', marginLeft: '20px' }}>Allocate working hours</span>
                </div>
                <div className="theme-checkbox form-check mb-0 mt-2">
                    <label style={{ fontWeight: '700', color: '#000', fontSize: '12px', marginLeft: '5px', textAlign: 'center', marginTop: '-2px' }} className="form-check-label" htmlFor="night_working">
                        Night Working
                    </label>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="night_working"
                        checked={isNightWorking}
                        onChange={(evt) => setIsNightWorking(evt.target.checked)}
                    />
                </div>
            </div>
            <div style={{ minHeight: '250px' }}>
                <div className="row">
                    <FormProvider {...methods}>
                        <div className="col-md-6 mt-4" >
                            <CustomTimePicker
                                errorMessage={formState.errors?.[apiConstants.start_time]?.message}
                                placeholder="Select time"
                                label="From"
                                onChange={(time: any) => {
                                    methods.setValue(apiConstants.start_time, time, { shouldValidate: true });
                                }}
                                value={startTime || null}
                            />
                        </div>
                        <div className='col-md-6 mt-4'>
                            <CustomTimePicker
                                errorMessage={formState.errors?.[apiConstants.end_time]?.message}
                                placeholder="Select time"
                                label="To"
                                onChange={(time: any) => {
                                    methods.setValue(apiConstants.end_time, time, { shouldValidate: true });
                                }}
                                value={endTime || null}
                            />
                        </div>
                    </FormProvider>
                </div>
                <button
                    style={{ minWidth: '110px', position: 'absolute', bottom: '30px', right: '25px' }}
                    className="btn btn-warning btn-sm"
                    onClick={methods.handleSubmit(onSubmit)}
                    type='submit'
                >
                    Save
                </button>
            </div>
        </Modal>
    )
}

export default AllocateTimeModal